import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'

import App from './App'
import KeyCloakProvider from 'keycloak/KeyCloakProvider'

const root = ReactDOM.createRoot(document.getElementById('root'))

const RootComponent = () => {
  // const getFirestoreConfigs = () => {
  //   return {
  //     f_api_key: 'string',
  //     f_app_id: 'string',
  //     f_auth_domain: 'string',
  //     f_measure_id: 'string',
  //     f_message_sender_id: 'string',
  //     f_project_id: 'string',
  //     f_storage_bucket: 'string',
  //     search_api_key: 'string'
  //   }
  // }
  return (
    <>
      <KeyCloakProvider>
        <App />
      </KeyCloakProvider>
    </>
  )
}
root.render(<RootComponent />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
